import moment from "moment";

import template from "./pIncomeImport.html";

export function pIncomeImportDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pIncomeImportController,
    controllerAs: 'pIncomeImport',
    bindToController: true
  };

  return directive;
}

class pIncomeImportController {
  constructor(Auth, Controlling, DownloadFile, Stats, $interval, $scope, $translate, Notes, bModal, Sort, ConnectionQuality) {
    'ngInject';
    this.DownloadFile = DownloadFile;
    this.Auth = Auth;
    this.Controlling = Controlling;
    this.Stats = Stats;
    this.Notes = Notes;
    this.bModal = bModal;
    this.Sort = Sort;
    this.ConnectionQuality = ConnectionQuality;
    this.$interval = $interval;
    this.$scope = $scope;
    this.$translate = $translate;
    this.anyAmount = null;
    this.excludeClientsWithNoTimeReported = false;

    this.modalConfig = {
      text: "CASEMAN.INCOME_OVERWRITE",
      cancelText: "CANCEL",
      acceptText: "Continue"
    };

    this.allProfitCentersSelected = true;
    this.allSitesSelected = true;
    this.allServiceLinesSelected = true;
    this.allTeamsSelected = true;
    this.profitCenters = [];

    this.incomeSumAllClients = 0;
    this.incomeSumTimeClients = 0;
    this.incomeSumNoTimeClients = 0;
    this.canImportFromCaseman = false;
    this.numberOfUnmatchedRecords = null;

    this.month = (moment().month()+1).toString();
    this.year = moment().year().toString();
    if (this.month.length == 1) {
      this.month = "0"+this.month;
    }
    this.state = "loading";
    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        if(!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then( newUserInfo => {
            this.user = newUserInfo;
            this.canImportFromCaseman = !!this.user.preferences.featureFlags.find(f => f == "CASEmanIncomeImport");
          });
        } else {
          this.canImportFromCaseman = !!this.user.preferences.featureFlags.find(f => f == "CASEmanIncomeImport");
        }

        this.Stats.getSubordinateIncome().then(
          (success) => {
            this.state = "loaded";

            // teams
            this.teams = success.data.teamWithSitesDto
              .filter(({ team })  => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : team.name != "Team Iterators")
              .map(({ team, sites }) => ({...team, selected: true, sites: sites}));
            const teamsActual = this.teams.filter(team => !team.archivedAt).sort(this.Sort.abcBy("name"));
            const teamsArchived = this.teams.filter(team => team.archivedAt).sort(this.Sort.abcBy("name"));
            this.teams = teamsActual.concat(teamsArchived);

            this.teamsDisplay = angular.copy(this.teams);

            this.profitCenters = success.data.profitCenters.sort(this.compare).map(pc => ({...pc, selected: true, numberOfTeams: this.teams.filter(t => t.profitCenterId == pc.id).length}));
            this.profitCentersDisplay = angular.copy(this.profitCenters);

            this.serviceLines = success.data.serviceLineWithSitesDto.sort(this.compare).map(sl => ({...sl, selected: true, numberOfTeams: this.teams.filter(t => t.serviceLine == sl.serviceLine).length}));
            this.serviceLinesDisplay = angular.copy(this.serviceLines);

            this.sitesMap = {};
            success.data.teamWithSitesDto.forEach(({ sites }) => {
              sites.forEach(site => {
                if (!this.sitesMap[site.id]) {
                  this.sitesMap[site.id] = site;
                }
              });
            });

            this.sites = Object.values(this.sitesMap).sort(this.Sort.abcBy("name")).map(s => ({...s, selected: true, numberOfTeams: this.teams.filter(t => t.sites.find(site => site.id == s.id)).length}));
            this.sitesDisplay = angular.copy(this.sites);
          },
          (error) => {
            this.state = "error";
            this.error = error;
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});

      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  preChangeServiceLines(name, newValue) {
    this.serviceLines.find(sl => sl.serviceLine == name).selected = newValue;

    this.resetData();
  }

  resetData() {
    this.allTeamsClients = undefined;
    this.withTimeTeamsClients = undefined;
    this.withIncomeNoTimeTeamsClients = undefined;
    this.selectedTeams = [];

    if (this.allProfitCentersSelected && this.profitCentersDisplay.find(c => c.selected != true)) {
      this.allProfitCentersSelected = false;
    }
    else if (!this.allProfitCentersSelected && this.profitCentersDisplay.every(c => c.selected == true)) {
      this.allProfitCentersSelected = true;
    }

    if (this.allSitesSelected && this.sitesDisplay.find(s => s.selected != true)) {
      this.allSitesSelected = false;
    }
    else if (!this.allSitesSelected && this.sitesDisplay.every(s => s.selected == true)) {
      this.allSitesSelected = true;
    }

    this.serviceLinesDisplay = this.serviceLines.filter(sl =>
      sl.sites.find(siteFromSL => this.sitesDisplay.filter(site => site.selected).map(site => site.id).includes(siteFromSL.id))
    );
    

    if (this.allServiceLinesSelected && this.serviceLinesDisplay.find(s => s.selected != true)) {
      this.allServiceLinesSelected = false;
    }
    else if (!this.allServiceLinesSelected && this.serviceLinesDisplay.every(s => s.selected == true)) {
      this.allServiceLinesSelected = true;
    }

    this.teamsDisplay = this.teams.filter(t => {
      if (
        (this.allProfitCentersSelected ? true : this.profitCentersDisplay.find(p => p.selected == true) ? (this.profitCentersDisplay.find(p => p.selected && p.id == t.profitCenterId)) : false)
        && (this.allSitesSelected ? true : this.sitesDisplay.find(s => s.selected == true) ? (this.sitesDisplay.find(s => s.selected && t.sites.find(site => s.id == site.id))) : false)
        && (this.allServiceLinesSelected ? true : this.serviceLinesDisplay.find(sl => sl.selected == true) ? (this.serviceLinesDisplay.find(sl => sl.selected && sl.serviceLine == t.serviceLine) || t.serviceLine == undefined) : false)
      ) {
        return t;
      } else {
        return null;
      }
    });

    if (this.allTeamsSelected && this.teamsDisplay.find(t => t.selected != true)) {
      this.allTeamsSelected = false;
    }
    else if (!this.allTeamsSelected && this.teamsDisplay.every(t => t.selected == true)) {
      this.allTeamsSelected = true;
    }
    if (this.isAnyProfitCenterSelected() === false && this.isAnySiteSelected() === false && this.isAnyServiceLineSelected() === false) {
      this.allTeamsSelected = false;
      this.selectAllTeams();
    }
    this.selectedTeams = this.teamsDisplay.filter(({selected}) => selected);
    this.ids = this.selectedTeams.map(({id}) => id);
  }

  filterTeams() {
    if (this.isAnyProfitCenterSelected() === false && this.isAnySiteSelected() === false && this.isAnyServiceLineSelected() === false) {
      this.allTeamsSelected = false;
      this.selectAllTeams();
    }
  }

  selectAllProfitCenters() {
    this.profitCentersDisplay.forEach(profitCenter => {
      if (this.allProfitCentersSelected) {
        profitCenter.selected = true;
      } else {
        profitCenter.selected = false;
      }
    });
    this.filterTeams();
    this.resetData();
  }

  selectAllSites() {
    this.sitesDisplay.forEach(s => {
      if (this.allSitesSelected) {
        s.selected = true;
      } else {
        s.selected = false;
      }
    });
    this.filterTeams();
    this.resetData();
  }

  selectAllServiceLines() {
    this.serviceLinesDisplay.forEach(s => {
      if (this.allServiceLinesSelected) {
        s.selected = true;
      } else {
        s.selected = false;
      }
    });
    this.filterTeams();
    this.resetData();
  }

  isAnyProfitCenterSelected() {
    const isAnyProfitCenterSelected = this.profitCentersDisplay.find(profitCenter => profitCenter.selected);
    return Boolean(isAnyProfitCenterSelected);
  }

  isAnySiteSelected() {
    const isAnySiteSelected = this.sitesDisplay.find(site => site.selected);
    return Boolean(isAnySiteSelected);
  }

  isAnyServiceLineSelected() {
    const isAnyServiceLineSelected = this.serviceLinesDisplay.find(serviceLine => serviceLine.selected);
    return Boolean(isAnyServiceLineSelected);
  }

  selectAllTeams() {
    this.teamsDisplay.forEach(c => {
      if (this.allTeamsSelected) {
        c.selected = true;
      } else {
        c.selected = false;
      }
    });
  }

  compare(a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  }

  selectTeam() {
    this.state = "loading";
    this.allTeamsClients = undefined;
    this.withTimeTeamsClients = undefined;
    this.withIncomeNoTimeTeamsClients = undefined;
    this.error = undefined;
    this.numberOfUnmatchedRecords = null;

    this.Controlling.getIncomeJson(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then(
      (incomeJsonSuccess) => {
        this.Controlling.getIncomeMappers(this.ids, this.year, this.month).then(
          (incomeMappersSuccess) => {
            this.handleIncomeJson(incomeJsonSuccess.data, incomeMappersSuccess.data);
            this.state = 'loaded';
          },
          (error) => {
            if (error.status !== 500) {
              this.state = "error";
              this.error = error;
            } else {
              this.handleIncomeJson(incomeJsonSuccess.data.dto, null);
              this.state = 'loaded';
            }
          }
        );
      },
      (error) => {
        this.state = "error";
        this.error = error;
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  prepareIncomes() {
    this.withTimeTeamsClients = this.allTeamsClients.filter(el => el.duration != 'PT0S');
    this.withIncomeNoTimeTeamsClients = this.allTeamsClients.filter(el => el.duration == 'PT0S' && el.amount && el.amount !== 0);

    this.anyAmount = this.excludeClientsWithNoTimeReported ? this.withTimeTeamsClients.find(e => e.amount) : this.allTeamsClients.find(e => e.amount);
    this.incomeSumAllClients = this.calculateSumForClients(this.allTeamsClients);
    this.incomeSumTimeClients = this.calculateSumForClients(this.withTimeTeamsClients);
    this.incomeSumNoTimeClients = this.calculateSumForClients(this.withIncomeNoTimeTeamsClients);
    this.totalIncome = this.incomeSumTimeClients + this.incomeSumNoTimeClients;
  }

  handleIncomeJson(incomeJson, incomeMappers) {
    const clientMappers = incomeMappers && incomeMappers.clientMappers;
    const clientProjectMappers = incomeMappers && incomeMappers.clientProjectMappers;
    const teamMappers = incomeMappers && incomeMappers.teamMappers;

    this.hasIncomeMappers = incomeMappers ? true : false;
    const income = incomeJson.map(inc => {
      let casemanClient;
      let casemanTeam;

      if (clientMappers)
        casemanClient = clientMappers.find(client => client.clientId === inc.clientId);
      else if (clientProjectMappers)
        casemanClient = clientProjectMappers.find(client => client.clientId === inc.clientId);

      if (teamMappers)
        casemanTeam = teamMappers.find(team => team.teamId === inc.teamId);

      inc.casemanClientOrProjectName = casemanClient && (casemanClient.casemanClientName ? casemanClient.casemanClientName : casemanClient.casemanProjectName);
      inc.casemanTeamName = casemanTeam && casemanTeam.casemanTeamName;

      return inc;
    });

    this.allTeamsClients = income.map(el => ({...el, noTime: el.duration == 'PT0S' && el.amount && el.amount !== 0}));
    this.prepareIncomes();
  }

  calculateSumForClients(clients) {
    return Math.round(clients.reduce((acc, curr) => acc + (curr.amount || 0), 0) * 100) / 100;
  }

  downloadTemplate() {
    this.state = "loading";
    this.error = undefined;
    this.Controlling.getIncomeExcel(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then((success) => {
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `income_report_${this.year}_${this.month}.xlsx`
        );
      this.state = "loaded";
    }, (error) => {
      this.state = "error";
      this.error = error;
      this.Notes.postNote({type: "error", error: error});
    });
  }

  fileChosen() {
    this.tempFile = undefined;
    this.loading = true;
    this.error = undefined;
    this.validFile = this.incomeExcelFile[0];
  }

  uploadIncomeExcel() {
    this.state = "loading";
    this.error = undefined;
    this.validFile = this.incomeExcelFile[0];
    this.Controlling.sendIncomeExcel(this.validFile, this.ids, this.year, this.month).then(() => {
      this.state = "loaded";
      this.selectTeam();
      this.validFile = null;
    }, (error) => {
      this.error = error;
      this.state = "loaded";
      this.Notes.postNote({type: "error", error: error});
    });
  }

  fetchCasemanIncome() {
    if (this.anyAmount) {
      this.bModal.show(this.modalConfig).then(() => this.doFetchCasemanIncome(), () => null);
    } else {
      this.doFetchCasemanIncome();
    }
  }

  fetchCasemanIncomeReport() {
    this.state = "loading";
    this.error = undefined;
    this.Controlling.fetchCasemanIncomeReport(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then((success) => {
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `sync_report_${this.year}_${this.month}.xlsx`
        );
      this.state = "loaded";
    }, () => {
      this.state = "loaded";
      this.Notes.postNote({type: "error", message: "Could not fetch income report, CASEman is down, please try again later"});
    });
  }

  doFetchCasemanIncome() {
    this.state = "loading";
    this.error = undefined;
    this.Controlling.fetchCasemanIncome(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then(({ data }) => {
      this.state = "loaded";
      this.selectTeam();
      this.numberOfUnmatchedRecords = data.numberOfUnmatched;
    }, (error) => {
      this.error = error;
      this.state = "loaded";
      this.Notes.postNote({type: "error", error: error});
    });
  }

  displayErrorMessage( message ) {
    if (message.includes('Wrong number of columns'))
      return this.$translate.instant('CONTROLLING.ERROR_NOTES.WRONG_NUMBER_COLUMNS');
    else if (message.includes('Couldn\'t find client or team'))
      return this.$translate.instant('CONTROLLING.ERROR_NOTES.NO_CLIENT_OR_TEAM');
    else if (message.includes('The amount cell is not a valid number'))
      return this.$translate.instant('CONTROLLING.ERROR_NOTES.NO_VALID_NUMBER');
    else if (message.includes('Can\'t convert string'))
      return this.$translate.instant('CONTROLLING.ERROR_NOTES.CANT_CONVERT');
    else if (message.includes('Upload xlsx income failed'))
      return this.$translate.instant('CONTROLLING.ERROR_NOTES.UPLOAD_FAILED');
    else if (message.includes('The request content was malformed'))
      return this.$translate.instant('CONTROLLING.ERROR_NOTES.INVALID_FORMAT');
    else if (message == 'File name has wrong format')
      return this.$translate.instant('CONTROLLING.ERROR_NOTES.WRONG_NAME_FORMAT');
    else
      return message;
  }

  editAmount(client) {
    client.newAmount = client.amount || '';
  }

  saveNewAmount(client) {
    this.state = "loading";
    this.Controlling.editAmount({
      yearMonth: `${this.year}-${this.month}`,
      incomes: [{
        teamId: client.teamId,
        clientId: client.clientId,
        amount: client.newAmount
      }]
    }).then(({ data }) => {
      client.amount = data[0].amount;
      client.incomeId = data[0].id;
      client.noTime = client.duration == 'PT0S' && client.amount && client.amount !== 0;

      this.cancelNewAmount(client);
      this.prepareIncomes();
      this.state = "loaded";
    }).catch((error) => {
      this.error = error;
      this.state = "loaded";
      this.Notes.postNote({type: "error", error: error});
    });
  }

  cancelNewAmount(client) {
    delete client.newAmount;
  }

  deleteAmount(client) {
    this.state = "loading";

    this.Controlling.deleteAmount(client.incomeId).then(() => {
      delete client.amount;
      client.noTime = client.duration == 'PT0S' && client.amount && client.amount !== 0;
      this.prepareIncomes();
      this.state = "loaded";
    }).catch((error) => {
      this.error = error;
      this.state = "loaded";
      this.Notes.postNote({type: "error", error: error});
    });
  }
}
